// Externals
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { getDynamicBffUrl } from '../../middleware/bffUrlMiddleware';

// Components
import { NavigationBar } from '@homeexchange/navigation-bar';

// Context
import { withCurrency } from '../currency';
import { GeoIPContext } from '../geoip/GeoIPProvider';

const NavigationBarOffline = (props) => {
    const { localeDescription, isScrollable, searchBarAlwaysVisible, appearance } = props;
    const { geoipLocal } = useContext(GeoIPContext);

    return (
        <NavigationBar
            session={{ status: 'anonymous' }}
            locale={localeDescription}
            apiUrl={getDynamicBffUrl(process.env.URL_BFF)}
            assetsUrl={process.env.URL_MIGRATION_ASSETS}
            jawgToken={process.env.JAWG_KEY}
            jawgUrl={process.env.URL_JAWG_URL}
            isScrollable={isScrollable}
            searchBarAlwaysVisible={searchBarAlwaysVisible}
            appearance={appearance}
            geoipLocal={geoipLocal}
        />
    );
};

NavigationBarOffline.propTypes = {
    localeDescription: PropTypes.string,
    isScrollable: PropTypes.bool,
    searchBarAlwaysVisible: PropTypes.bool,
    appearance: PropTypes.string
};

NavigationBarOffline.defaultProps = {
    isScrollable: false,
    searchBarAlwaysVisible: false,
    appearance: 'dark'
};

const mapStateToProps = (state) => ({
    localeDescription: state.localeDescription
});

export default compose(connect(mapStateToProps), withCurrency)(NavigationBarOffline);
